import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../context/CurrencyContext';
import { CURRENCIES } from '../utils/currency';
import './CurrencySwitcher.css';

const CurrencySwitcher = () => {
  const { t } = useTranslation();
  const { currency, setCurrency, meta } = useCurrency();
  const [open, setOpen] = useState(false);

  const select = (code) => {
    setCurrency(code);
    setOpen(false);
  };

  return (
    <div className="currency-switcher">
      <button
        type="button"
        className="currency-button"
        onClick={() => setOpen((v) => !v)}
        aria-label={t('currency.label')}
        aria-expanded={open}
      >
        <span className="currency-symbol">{meta.symbol}</span>
        <span className="currency-code">{currency}</span>
        <span className={`currency-arrow ${open ? 'open' : ''}`}>▼</span>
      </button>

      <div className={`currency-menu ${open ? 'open' : ''}`}>
        {CURRENCIES.map((c) => (
          <button
            key={c.code}
            type="button"
            className={`currency-option ${currency === c.code ? 'active' : ''}`}
            onClick={() => select(c.code)}
          >
            <span className="currency-symbol">{c.symbol}</span>
            {c.code}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CurrencySwitcher;
